import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignItems: "center",
      // backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.common.white}`,
      borderRadius: theme.shape.borderRadius,
      display: "flex",
      minHeight: theme.spacing(5),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      position: "relative",
    },
    paper: {
      // borderRadius: theme.shape.borderRadius,
    },
    labelWrapper: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      lineHeight: 1.1,
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    },
    labelTitle: {
      fontStyle: "italic",
      lineHeight: 1.2,
    },
    label: {
      // color: theme.palette.text.primary,
      lineHeight: 1.2,
    },
    resetButton: {
      padding: 5,
    },
  })
);
